/**
 * Escapes HTML special characters to prevent XSS injection.
 * Equivalent to the backend DenyAllSanitizerConfig — all HTML is neutralized.
 *
 * @param {string} value - The string to sanitize
 * @returns {string} The escaped string safe for HTML rendering
 */
const escapeHtml = (value) => {
    if (typeof value !== 'string') {
        return value;
    }

    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};

export { escapeHtml };
